import InheritRuleTemplateModel from "./InheritRuleTemplateModel.js";
import NoRuleTemplateModel from "./NoRuleTemplateModel.js";
import OwnRuleTemplateModel from "./OwnRuleTemplateModel.js";

/**
 * Helper to build a RuleTemplateModel instance for a row and column.
 *
 * @param {Column} column - Column of the cell for which to create a RuleTemplateModel
 * @param {AbstractRow} row - Row of the cell for which to create a RuleTemplateModel
 * @param {ForecastEditorDocumentState} documentState - Document state holding all the rules
 *   for a report
 * @param {AbstractRuleModel} ruleModelClass - Class of the rule to retrieve
 * @param {RuleTemplate} defaultRuleTemplate - Rule template to use when none is found
 *   in the document state
 */
export default function makeRuleTemplateModel({
	column,
	row,
	documentState,
	ruleModelClass,
	defaultRuleTemplate,
}) {
	const ownRule = documentState.getOwnRuleTemplateFor({
		row,
		column,
		ruleModelClass,
	});

	if (ownRule) {
		return new OwnRuleTemplateModel({ ruleTemplate: ownRule });
	}

	const inheritedRule = documentState.getInheritedRuleTemplateFor({
		row,
		column,
		ruleModelClass,
	});

	if (inheritedRule) {
		return new InheritRuleTemplateModel({
			report: documentState.getCurrentReport(),
			inheritedRuleTemplate: inheritedRule,
			ruleTemplate: defaultRuleTemplate,
		});
	}

	return new NoRuleTemplateModel({ ruleTemplate: defaultRuleTemplate });
}
